export const START_OPERATION = 'START_OPERATION';
export default function startOperation(id) {
  return {
    type: START_OPERATION,
    id,
  };
}
